import script from "./search-bar.vue?vue&type=script&setup=true&lang=ts"
export * from "./search-bar.vue?vue&type=script&setup=true&lang=ts"

import "./search-bar.vue?vue&type=style&index=0&id=617eb1ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-617eb1ea"]])

export default __exports__